export default __webpack_public_path__ + "static/media/dormitorio-desktop.455b8db9.jpg";